import { defaultLocale } from "infrastructure/localization";

import { ITermWithTranslations } from "./TermTranslations.state";

export const mergeTermWithTranslations = (termWithTranslations: ITermWithTranslations) => {
  return [
    {
      translationId: "",
      termId: termWithTranslations.term.termId,
      localeName: defaultLocale.name,
      industryDescription: "",
      translation: termWithTranslations.term.term,
      definition: termWithTranslations.term.definition,
      source: "",
      status: ""
    },
    ...termWithTranslations.translations
  ];
};
